module.exports = __webpack_public_path__ + "img/google-pay.95f3d7cc.svg";